// ---------------------------------------------------------------------------
// slugify.ts — Fallback slug generation for departments without a NERIS ID.
// When a NERIS ID is present, the slug IS the NERIS ID (lowercased).
// This utility is only used when no NERIS ID has been assigned.
// ---------------------------------------------------------------------------

export function generateSlug(name: string): string {
  return name
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .substring(0, 63);
}
